import React, {Component} from 'react'
import {object, number} from 'prop-types'
import acc from 'accounting'
// import cn from 'classnames'

class Subjects extends Component {
  _renderRequisites(subject) {
    let pre = subject.get('prereq').map(s => s.get('code')).toJS()
    let co = subject.get('coreq').map(s => s.get('code')).toJS()
    let st = ''
    if (subject.get('standing') !== '0') {
      st = ' ; ST:' + subject.get('standing')
    }

    pre = pre.join(', ')
    co = co.join(', ')
    co = co ? ' / ' + co : co
    return <div><small>{pre}{co}{st}</small></div>
  }

  render() {
    const {meta, subjects} = this.props
    // const pageCL = cn({"page-break": k === 5})

    return (
      <div>
        <table className="curriculum-subjects table">
          <thead>
            <tr>
              <th colSpan="2">
                Year: {meta.get('year')} | Semester: {meta.get('sem')}
              </th>
              <th width="5%" className="text-center" colSpan="2">Hours</th>
              <th width="5%" className="text-center" colSpan="2">Units</th>
              <th width="5%" className="text-right" />
              <th width="20%" />
            </tr>
            <tr>
              <th width="15%">Subject Code</th>
              <th>Subject Description</th>
              <th width="5%" className="text-right">Lec</th>
              <th width="5%" className="text-right">Lab</th>
              <th width="5%" className="text-right">Lec</th>
              <th width="5%" className="text-right">Lab</th>
              <th width="5%" className="text-right">Total</th>
              <th width="20%">Pre/Co Requisites;Standing</th>
            </tr>
          </thead>
          <tbody>
            {subjects.map((d, k) => {
              return (
                <tr key={k}>
                  <td>{d.get('code')}</td>
                  <td>{d.get('name')}</td>
                  <td className="text-right">
                    {acc.formatNumber(d.get('lec_hrs'), 1)}
                  </td>
                  <td className="text-right">
                    {acc.formatNumber(d.get('lab_hrs'), 1)}
                  </td>
                  <td className="text-right">
                    {acc.formatNumber(d.get('lec_units'), 1)}
                  </td>
                  <td className="text-right">
                    {acc.formatNumber(d.get('lab_units'), 1)}
                  </td>
                  <td className="text-right">
                    {acc.formatNumber(d.get('units'), 1)}
                  </td>
                  <td>{this._renderRequisites(d)}</td>
                </tr>
              )
            })}
            <tr>
              <th colSpan="2" />
              <th className="text-right" colSpan="2">Sub Total:</th>
              <th width="5%" className="text-right">
                {acc.formatNumber(meta.get('total_lec'), 1)}
              </th>
              <th width="5%" className="text-right">
                {acc.formatNumber(meta.get('total_lab'), 1)}
              </th>
              <th width="5%" className="text-right">
                {acc.formatNumber(meta.get('total'), 1)}
              </th>
              <th width="20%" />
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

Subjects.propTypes = {
  meta: object,
  subjects: object,
  k: number,
}

export default Subjects



// WEBPACK FOOTER //
// ./src/containers/Print/Curriculums/subjects.js